// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label-div[data-v-61ae3202] {\n  color: var(--dark-green-60, #66827f);\n}\n.clear-btn-div[data-v-61ae3202] {\n  color: var(--green);\n  text-decoration: underline;\n}\n.clear-btn-div[data-v-61ae3202]:hover {\n  color: var(--sea);\n  transition: var(--d-ease);\n}", ""]);
// Exports
module.exports = exports;
